import { use, Suspense, useState, useEffect } from "react";
import { CardComponentProps } from "@~/types/types";
import { useFeatureFlags } from "@~/flags/flags";
import { SocialProofMessage } from "./SocialProofMessage";
import styles from "./SocialProofMessaging.module.scss";

function SocialProofMessagingContent({
  product,
  usePremiumFont,
}: Pick<CardComponentProps, "product"> & { usePremiumFont: boolean }) {
  const messages = product.socialProofMessages
    ? use(product.socialProofMessages)
    : undefined;

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div
      data-component="pcl-SocialProofMessaging"
      className={styles.socialProofMessage}
    >
      <SocialProofMessage
        message={`${messages[0]?.title}`}
        usePremiumFont={usePremiumFont}
      ></SocialProofMessage>
    </div>
  );
}

export function SocialProofMessaging({
  product,
  usePremiumFont,
}: Pick<CardComponentProps, "product"> & { usePremiumFont?: boolean }) {
  const { socialProofPremiumFont } = useFeatureFlags();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(function markSocialProofAsMounted() {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <SocialProofMessagingContent
        product={product}
        usePremiumFont={usePremiumFont ?? !!socialProofPremiumFont?.value}
      />
    </Suspense>
  );
}
